var map = {
	"./adams.jpg": 436,
	"./alekseenko.jpg": 437,
	"./anton guijarro.jpg": 438,
	"./anton guijarro2.jpg": 439,
	"./anton-150x150.jpg": 440,
	"./calzetta.jpg": 441,
	"./carlsen.jpg": 442,
	"./caruana.jpg": 443,
	"./cramling.jpg": 444,
	"./ding.jpg": 445,
	"./dingliren.jpg": 446,
	"./duda.jpg": 447,
	"./edouard.jpg": 448,
	"./eduardoiturrizaga-150x150.jpg": 449,
	"./esipenko.jpg": 450,
	"./firouzja.jpg": 451,
	"./gara.jpg": 452,
	"./giri.jpg": 453,
	"./gukesh d.jpg": 454,
	"./gukesh.jpg": 455,
	"./harikrishna.jpg": 456,
	"./iturrizaga bonelli.jpg": 457,
	"./iturrizaga.jpg": 458,
	"./ivanchuk.jpg": 459,
	"./javakhishvili.jpg": 460,
	"./kamsky.jpg": 461,
	"./keymer.jpg": 462,
	"./khademalsharieh.jpg": 463,
	"./kosteniuk.jpg": 464,
	"./mammadzada.jpg": 465,
	"./matnadze.jpg": 466,
	"./muzychuk.jpg": 467,
	"./nakamura.jpg": 468,
	"./nepomniachtchi.jpg": 469,
	"./nurgyul-salimova-150x150.jpg": 470,
	"./paehtz.jpg": 471,
	"./ponomariov.jpg": 472,
	"./radjabov.jpg": 473,
	"./raport.jpg": 474,
	"./rapport.jpg": 475,
	"./sabrinavega-150x150.jpg": 476,
	"./salimova.jpg": 477,
	"./santos latasa.jpg": 478,
	"./shirov.jpg": 479,
	"./skripchenko-150x150.jpg": 480,
	"./skripchenko.jpg": 481,
	"./socko.jpg": 482,
	"./tari.jpg": 483,
	"./topalov-150x150.jpg": 484,
	"./topalov.jpg": 485,
	"./ushenina.jpg": 486,
	"./vega gutierrez.jpg": 487
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;



//////////////////
// WEBPACK FOOTER
// ./static/images/personas ^\.\/.*\.jpg$
// module id = 580
// module chunks = 10